import { useState, useEffect } from 'react';
import AppDownload from './AppDownload';
import HoneymoonFund from './HoneymoonFund';

const BASE = '/photos';
const photoWembley = `${BASE}/wembley.jpeg`;
const photoPierogi = `${BASE}/pierogi.jpeg`;
const photoBoatGreece = `${BASE}/boat-greece.jpeg`;
const photoPulpitRock = `${BASE}/pulpit-rock.jpeg`;
const photoTheAvenue = `${BASE}/the-avenue.jpeg`;
const photoMarbella = `${BASE}/marbella.jpeg`;
const photoPulpitRock2 = `${BASE}/pulpit-rock-2.jpeg`;
const photoIceland = `${BASE}/iceland.jpeg`;
const photoYork = `${BASE}/york.jpeg`;
const photoPieceHall = `${BASE}/piece-hall.jpeg`;
const photoGoApe = `${BASE}/go-ape.jpeg`;
const photoVerona = `${BASE}/verona.jpeg`;
const photoSafari = `${BASE}/safari.jpeg`;
const photoFlares = `${BASE}/flares.jpeg`;
const photoIoannina = `${BASE}/ioannina.jpeg`;

function Home() {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);

  useEffect(() => {
    const countdown = () => {
      const countDate = new Date("September 19, 2026 13:00:00").getTime();
      const now = new Date().getTime();
      const gap = countDate - now;

      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      setDays(Math.floor((gap % (day * 365)) / day));
      setHours(Math.floor((gap % day) / hour));
      setMinutes(Math.floor((gap % hour) / minute));
    };

    countdown();
    const interval = setInterval(countdown, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container">
      <div className="content invite">
        <h2 className="josefin-slab upper">Together with our families, we joyfully invite you to the wedding of</h2>
        <h1 className="tangerine-bold">Catherine Mary Sellick &amp; Oliver William Binns</h1>
      </div>

      <AppDownload />

      <div className="album">
        <div className="photo">
          <img src={photoWembley} alt="Two people smiling and posing in front of a football stadium. The stadium is filled with red seats and a green pitch. The people are standing behind a railing, looking out at the field." />
          <div className="caption">Watching the Lionesses at Wembley Stadium</div>
        </div>

        <div className="photo">
          <img src={photoPierogi} alt="Two people wearing aprons stand in front of a sign that says 'pierogi & more'. They are smiling and holding a tray of uncooked pierogi. The setting appears to be a cooking class or workshop." />
          <div className="caption">Making pierogi in Poland</div>
        </div>

        <div className="photo">
          <img src={photoBoatGreece} alt="Cat and Oliver smiling and posing on a boat. They are wearing white shirts and glasses, and the background shows a calm sea and distant mountains under a clear blue sky." />
          <div className="caption">Boat trip in Greece</div>
        </div>

        <div className="photo">
          <img src={photoPulpitRock} alt="Two people sitting on a rock, facing each other and smiling. They are wearing hoodies and looking out over a mountainous landscape. The sky is overcast, creating a serene atmosphere." />
          <div className="caption">Early morning walk up Pulpit Rock, Norway</div>
        </div>

        <div className="photo">
          <img src={photoTheAvenue} alt="Two people smiling and posing in front of a window with a blackboard. The blackboard has text and illustrations on it. There are shelves with books and kitchenware to the right of the window." />
          <div className="caption">Learning at the Avenue Cookery School</div>
        </div>

        <div className="photo">
          <img src={photoMarbella} alt="A couple posing on a sandy beach during sunset. The woman is wearing a white dress, and the man is in a white shirt and pants. In the background, there are people near the water and a boat on the sand." />
          <div className="caption">On the beach in Marbella</div>
        </div>

        <div className="photo">
          <img src={photoPulpitRock2} alt="Two people sitting on a rock, facing each other and smiling. They are wearing hoodies and looking out over a mountainous landscape. The sky is overcast, creating a serene atmosphere." />
          <div className="caption">Early morning walk up Pulpit Rock, Norway</div>
        </div>

        <div className="photo">
          <img src={photoIceland} alt="Two people in winter coats posing in front of a frozen lake and snow-covered mountains. The man is wearing glasses and a mustard yellow jacket, while the woman has a fur-lined hood. They are smiling and standing close together on a balcony or viewing platform." />
          <div className="caption">Exploring Iceland’s Golden Circle</div>
        </div>

        <div className="photo">
          <img src={photoYork} alt="Two people smiling and holding cocktails outside a shop with a sign reading 'Rowntree & Sons'. The shop window displays vintage packaging and products. The scene is warmly lit." />
          <div className="caption">Gin & chocolate tasting in York</div>
        </div>

        <div className="photo">
          <img src={photoPieceHall} alt="Two people smiling and posing in front of a music stage. The stage has a sign that says 'Abraham Alexander' and a crowd of people is gathered in front of it. The sky is cloudy and there is a building with balconies in the background." />
          <div className="caption">A gig at the Piece Hall</div>
        </div>

        <div className="photo">
          <img src={photoGoApe} alt="Two people smiling and posing for a selfie in front of trees. One person is holding a red pulley attached to a rope. They appear to be enjoying an outdoor adventure." />
          <div className="caption">Climbing through the trees at Go Ape</div>
        </div>

        <div className="photo">
          <img src={photoVerona} alt="Two people smiling and posing in front of a cityscape. The man is wearing a blue t-shirt with a museum logo, and the woman is in a patterned blouse with a red strap. The background shows a sprawling city with red-roofed buildings under a cloudy sky." />
          <div className="caption">Exploring the Verona skyline</div>
        </div>

        <div className="photo">
          <img src={photoSafari} alt="Oliver and Cat stood in front of a safari vehicle." />
          <div className="caption">On Safari in South Africa</div>
        </div>

        <div className="photo">
          <img src={photoFlares} alt="Two people wearing red hats and smiling. One person is holding a bottle and a cup. They appear to be in a dimly lit room." />
          <div className="caption">Partying at Flares</div>
        </div>

        <div className="photo">
          <img src={photoIoannina} alt="Two people smiling and sitting at a table with plates of food on a wooden deck overlooking a lake and mountains." />
          <div className="caption">Enjoying dinner in Ioannina</div>
        </div>
      </div>

      <HoneymoonFund />

      <div className="content invite">
        <table className="countdown-timer" style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td className="days">{days}</td>
              <td className="hours">{hours}</td>
              <td className="minutes">{minutes}</td>
            </tr>
            <tr>
              <td className="days-label">{days === 1 ? 'day' : 'days'}</td>
              <td className="hours-label">{hours === 1 ? 'hour' : 'hours'}</td>
              <td className="minutes-label">{minutes === 1 ? 'minute' : 'minutes'}</td>
            </tr>
          </tbody>
        </table>
        <h2 className="josefin-slab upper">
          Until The <u>Big</u> Day
        </h2>
      </div>
    </div>
  )
}

export default Home;